import Handlebars from "handlebars-template-loader/runtime";

Handlebars.registerHelper("pluralize", (count, singular, plural) => {
  return count === 1 ? singular : plural;
});
